import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

const isNative = (): boolean =>
  typeof Capacitor !== "undefined" && Capacitor.isNativePlatform();

// In-memory cache — только в JS-памяти, не в localStorage
// XSS может прочитать это через eval, но:
// 1. accessToken живёт только 15 минут
// 2. refreshToken здесь НЕ хранится (он в HttpOnly cookie)
const memoryStore = new Map<string, string>();

export const SecureStorage = {
  async get(key: string): Promise<string | null> {
    if (isNative()) {
      const result = await Preferences.get({ key });
      return result.value;
    }

    if (key === "refreshToken") {
      // refreshToken на web — в HttpOnly cookie (управляет браузер)
      // JS не может его прочитать — это и есть цель
      // Для логики "есть ли рефреш токен" используем флаг в памяти:
      return memoryStore.get("hasRefreshToken") ? "__cookie__" : null;
    }

    // accessToken — только в памяти, не в localStorage
    return memoryStore.get(key) ?? null;
  },

  async set(key: string, value: string): Promise<void> {
    if (isNative()) {
      await Preferences.set({ key, value });
      return;
    }

    if (key === "refreshToken") {
      // На web: refreshToken приходит через Set-Cookie с бэкенда
      // Здесь только устанавливаем флаг "токен есть"
      memoryStore.set("hasRefreshToken", "true");
      return;
    }

    // accessToken — только в памяти
    memoryStore.set(key, value);
    // не localStorage.setItem
  },

  async remove(key: string): Promise<void> {
    if (isNative()) {
      await Preferences.remove({ key });
      return;
    }
    memoryStore.delete(key);
    if (key === "refreshToken") {
      memoryStore.delete("hasRefreshToken");
      // Cookie удаляется через API: POST /auth/logout
    }
  },

  async clear(): Promise<void> {
    if (isNative()) {
      await Preferences.clear();
      return;
    }
    memoryStore.clear();
    // refreshToken cookie удаляется через POST /auth/logout
  },

  getAccessTokenSync(): string | null {
    return memoryStore.get("accessToken") ?? null;
  },
};
